

function MobileNav() {
  return (
    <i class="bi bi-list mobile-nav-toggle d-xl-none"></i>
  );
}

export default MobileNav;
